import React, { useEffect } from 'react';

import { apiAppDownLoad } from 'api/ZimssaAPI';

function AppDownLoad(): React.ReactElement {
  const handleError = () => {
    alert('정보를 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요.');
    window.location.href = '/';
  };

  useEffect(() => {
    // 짐싸 파트너앱 플레이스토어 URL 호출
    apiAppDownLoad()
      .then((response) => {
        const { result, data: storeUrl } = response;
        if (result === 'success') {
          window.location.href = storeUrl;
        } else {
          handleError();
        }
      })
      .catch(() => {
        handleError();
      });
  }, []);

  return <div></div>;
}

export default AppDownLoad;
